<template>
  <div class="countdown_timer_container"
  :class="$mq"
  >
    
    <div class="container">
      <div class="row">
        <div class="col-12">
          
          <card-generic
          :title="title"
          title_class="teal"
          v-if="show_countdown"
          >
            
            <div class="countdown_cell_container">
              <div class="countdown_cell">
                <span class="countdown_val">{{days}}</span>
                <span class="countdown_label">Days</span>
              </div>
              <div class="countdown_cell">
                <span class="countdown_val">{{hours}}</span>
                <span class="countdown_label">Hours</span>
              </div>
              <div class="countdown_cell">
                <span class="countdown_val">{{minutes}}</span>
                <span class="countdown_label">Minutes</span>
              </div>
              <div class="countdown_cell">
                <span class="countdown_val">{{seconds}}</span>
                <span class="countdown_label">Seconds</span>
              </div>
            </div>

          </card-generic>

        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import CardGeneric from '@/components/cards/card_generic.vue';

/*
Example "target_date" = '01/20/2018 12:00 AM UTC-0500'
*/
export default {
  name: 'countdown_timer',
  props: [
    'target_date',
    'title'
  ],
  data () {
    return {
      show_countdown: true,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      timeout_period: 990,
      gsecs: 0,
      now: new Date(),
      current_target_date: this.target_date
    }
  },
  created() {
    // this.trigger_countdown();
    if(this.current_target_date != '') {
      this.trigger_countdown();
    }
  },
  watch: {
    target_date: function(new_val, old_val) {
      if(new_val != '') {
        this.current_target_date = new_val;
        this.trigger_countdown();
      }
    }
  },
  methods: {
    trigger_countdown: function() {
      this.gsecs = this.get_time_diff();
      this.count_backward(this.gsecs);
    },
    count_backward: function(secs) {
      let vm = this;

      // IF TIMER HAS ELAPSED, STOP LOOPING
      if(secs <= 0) {
        vm.show_countdown = false;
        return false;
      }

      // CALC DAYS
      vm.days = vm.calcage(secs,86400,100000);
      vm.hours = vm.calcage(secs,3600,24);
      vm.minutes = vm.calcage(secs,60,60);
      vm.seconds = vm.calcage(secs,1,60);

      // SET TIMEOUT FOR LOOP
      setTimeout(function() {
        vm.count_backward((secs - 1));
      }, vm.timeout_period);
    },
    calcage: function(secs, num1, num2) {
      let s = ((Math.floor(secs/num1))%num2).toString();
      if(s.length < 2) {
        s = "0" + s;
      }
      return s;
    },
    get_time_diff: function() {
      let target = new Date(this.current_target_date);
      let diff = new Date(target - this.now);
      return Math.floor(diff.valueOf()/1000);
    }
  },
  components: {
    CardGeneric
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.countdown_cell_container {

  .countdown_cell {
    display: inline-block;
    width: 23%;
    text-align: center;


  }

  .countdown_val, .countdown_label {
    display: block;
  }

  .countdown_val {
    font-weight: bold;
    font-size: 1.6em;
  }

  .countdown_label {
    
  }

  &.desktop, &.laptop {
    
  }

}
</style>



// WEBPACK FOOTER //
// src/features/countdown/countdown_timer.vue